import { IFilterWrapper } from 'src/app/library/interfaces/filters/filter-wrapper';
import { DataResponseWrapper } from './data-response-wrapper';

export class PagedCollectionFilterResponseWrapper<
    T
> extends DataResponseWrapper<T> {
    filterWrapper: IFilterWrapper;
    nextPage: string;
    previousPage: string;
    totalResults: number;

    constructor(
        filterWrapper: IFilterWrapper,
        data: T,
        nextPage: string,
        previousPage: string,
        totalResults: number,
        success: boolean,
        message: string
    ) {
        super(success, message, data);

        this.filterWrapper = filterWrapper;
        this.nextPage = nextPage;
        this.previousPage = previousPage;
        this.totalResults = totalResults;
    }
}
